export default __webpack_public_path__ + "static/media/frog-background.ff9a9ba5.svg";